import type { TerminalMessage } from "../types";

export interface PersistedState {
  activeProviderId?: string;
  messages?: TerminalMessage[];
  /** providerId -> apiKey. Only written when persistApiKeys is enabled. */
  apiKeys?: Record<string, string>;
  panelHeight?: number;
}

function key(namespace: string): string {
  return `${namespace}:state`;
}

function storage(): Storage | null {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    // Access to localStorage can throw (privacy mode, sandboxed iframe).
    return null;
  }
}

export function loadState(namespace: string): PersistedState {
  const s = storage();
  if (!s) return {};
  try {
    const raw = s.getItem(key(namespace));
    return raw ? (JSON.parse(raw) as PersistedState) : {};
  } catch {
    return {};
  }
}

export function saveState(namespace: string, state: PersistedState): void {
  const s = storage();
  if (!s) return;
  try {
    s.setItem(key(namespace), JSON.stringify(state));
  } catch {
    // Quota or serialization failure — persistence is best-effort.
  }
}

export function clearState(namespace: string): void {
  storage()?.removeItem(key(namespace));
}
